import { render } from "./ApprovePayments.vue?vue&type=template&id=51902c08"
import script from "./ApprovePayments.vue?vue&type=script&lang=js"
export * from "./ApprovePayments.vue?vue&type=script&lang=js"

import "./ApprovePayments.vue?vue&type=style&index=0&id=51902c08&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__